import { motion } from "framer-motion";
import { useState, useEffect, useRef } from "react";

const AnimatedLi = ({ children, duration = 0.8, offset = 50 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasAppeared, setHasAppeared] = useState(false); // 🔥 Nouvelle variable pour bloquer la disparition
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          setHasAppeared(true); // 🔥 Bloque la disparition après l'apparition
        }
      },
      {
        root: null,
        rootMargin: `0px 0px -${offset}px 0px`, // Déclenche avant d'être 100% visible
        threshold: 0.2, // Se déclenche quand 20% de l’élément est visible
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [offset]);

  return (
    <motion.li
      className="li_agence"
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={hasAppeared ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }} // 🔥 Ne redevient plus invisible
      transition={{ duration, ease: "easeOut" }}
    >
      {children}
    </motion.li>
  );
};

export default AnimatedLi;
